import React, { useState, useEffect } from "react";
import axios from "axios";
import { HiPlus, HiPencil, HiTrash } from "react-icons/hi";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PreferredLanguage() {
  const [languages, setLanguages] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get("http://localhost:5890/prefenenceLanguage", {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      setLanguages(res.data);
    } catch (err) {
      console.error("Error fetching languages:", err);
      toast.error("Failed to load preferred languages.");
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setName("");
    setEditId(null);
  };

  const handleSave = async () => {
    if (!name.trim()) {
      toast.warning("Please enter a language name.");
      return;
    }

    setIsSaving(true);
    const token = sessionStorage.getItem("token");

    try {
      if (editId) {
        // Update existing language
        await axios.put(
          `http://localhost:5890/prefenenceLanguage/${editId}`,
          { name },
          { 
            headers: { 
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            } 
          }
        );
        toast.success("Language updated successfully.");
      } else {
        // Add new language
        await axios.post(
          "http://localhost:5890/prefenenceLanguage",
          { name },
          { 
            headers: { 
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            } 
          }
        );
        toast.success("Language added successfully.");
      }

      // Close modal and refresh data
      const modal = bootstrap.Modal.getInstance(document.getElementById('languageModal'));
      if (modal) modal.hide();
      fetchLanguages();
      resetForm();
    } catch (err) {
      console.error("Error saving language:", err);
      toast.error(err.response?.data?.error || "Failed to save language.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this language?")) {
      try {
        await axios.delete(`http://localhost:5890/prefenenceLanguage/${id}`, {
          headers: { 
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            'Content-Type': 'application/json'
          },
        });
        toast.success("Language deleted successfully.");
        fetchLanguages();
      } catch (err) {
        console.error("Error deleting language:", err);
        toast.error(err.response?.data?.error || "Failed to delete language.");
      }
    }
  };

  const openEditModal = (language) => {
    setEditId(language.id || language._id); // Handle both id and _id
    setName(language.name);
    
    // Show modal using Bootstrap
    const modalElement = document.getElementById('languageModal');
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  };

  const openAddModal = () => {
    resetForm();
    const modalElement = document.getElementById('languageModal');
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  };

  const filteredLanguages = languages.filter((lang) =>
    lang.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container my-4">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="bg-white p-4 shadow rounded-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="fw-bold m-0">Preferred Languages</h3>
          <button
            className="btn btn-success d-flex align-items-center gap-2"
            onClick={openAddModal}
          >
            <HiPlus /> Add Language
          </button>
        </div>

        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search Preferred Language..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="table-responsive">
          {isLoading ? (
            <div className="text-center py-4">Loading...</div>
          ) : (
            <table className="table table-striped align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Language</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredLanguages.length > 0 ? (
                  filteredLanguages.map((lang, index) => (
                    <tr key={lang.id || lang._id}>
                      <td>{index + 1}</td>
                      <td>{lang.name}</td>
                      <td>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => openEditModal(lang)}
                          >
                            <HiPencil />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(lang.id || lang._id)}
                          >
                            <HiTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted py-4 fst-italic">
                      No preferred language found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="languageModal"
        tabIndex="-1"
        aria-labelledby="languageModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 shadow">
            <div className="modal-header bg-success text-white rounded-top-4">
              <h5 className="modal-title" id="languageModalLabel">
                {editId ? "Edit Language" : "Add Language"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <label className="form-label fw-semibold">Language Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter language name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handleSave();
                }}
              />
            </div>
            <div className="modal-footer bg-light rounded-bottom-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSave}
                disabled={isSaving || !name.trim()}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {editId ? "Updating..." : "Adding..."}
                  </>
                ) : editId ? (
                  "Update"
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}